import { DatePickerCustomAttribute } from './custom-attributes/date-picker';
import { IRegistry } from 'aurelia';
import { FixScroll } from './custom-attributes/fix-scroll';
import { Toggle } from './custom-attributes/toggle';
import { AbnLookup } from './custom-elements/abn-lookup/abn-lookup';
import { SummaryPanel } from './custom-elements/summary-panel/summary-panel';
import { Wizard } from './custom-elements/wizard/wizard';
import { Step } from './custom-elements/wizard/step';
import { IaModal } from './custom-elements/ia-modal/ia-modal';

import ValidationMessages from './custom-elements/validation-messages/validation-messages.html';
import Grid from './custom-elements/grid/grid.html';
import { Payment } from './custom-elements/payment/payment';
import { PremiumFunder } from './custom-elements/premium-funder/premium-funder';
import { LoginRegister } from './custom-elements/login-register/login-register';
import { Tooltip } from './custom-elements/tooltip/tooltip';
import { RecaptchaCustomElement } from './custom-elements/recaptcha/recaptcha';
import { LoadingIndicator } from './custom-elements/loading-indicator/loading-indicator';
import { AbnFormatValueConverter } from './value-converters/abn-format';
import { NumberToEnumValueConverter } from './value-converters/number-to-enum';
import { CurrencyFormatValueConverter } from './value-converters/currency-format';
import { LoadViewValueConverter } from './value-converters/load-view';
import { IaPhoneNumber } from './custom-elements/ia-phone-number';

export const Components: IRegistry[] = [
    FixScroll as unknown as IRegistry,
    Toggle as unknown as IRegistry,
    DatePickerCustomAttribute as unknown as IRegistry,
    AbnLookup as unknown as IRegistry,
    SummaryPanel as unknown as IRegistry,
    Wizard as unknown as IRegistry,
    Step as unknown as IRegistry,
    IaModal as unknown as IRegistry,
    ValidationMessages as unknown as IRegistry,
    Grid as unknown as IRegistry,
    Payment as unknown as IRegistry,
    PremiumFunder as unknown as IRegistry,
    LoginRegister as unknown as IRegistry,
    Tooltip as unknown as IRegistry,
    RecaptchaCustomElement as unknown as IRegistry,
    LoadingIndicator as unknown as IRegistry,
    AbnFormatValueConverter as unknown as IRegistry,
    NumberToEnumValueConverter as unknown as IRegistry,
    CurrencyFormatValueConverter as unknown as IRegistry,
    LoadViewValueConverter as unknown as IRegistry,
    IaPhoneNumber as unknown as IRegistry
];
